// extracted by mini-css-extract-plugin
export default {"questionExplanation":"bB_cv"};